var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "ranking",
    class: _vm.isMobile && 'wap'
  }, [_c('p-head'), _c('div', {
    staticClass: "ranking-main main",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "ranking-title"
  }, [_vm._v(_vm._s(_vm.$lang("Ranking")))]), _c('div', {
    staticClass: "ranking-sub"
  }, [_vm._v(_vm._s(_vm.$lang("The data was last updated at 2024/11/25 01:23:47 (UTC)")))]), _c('div', {
    staticClass: "ranking-msc"
  }, [_c('div', {
    staticClass: "ranking-con"
  }, [_c('div', {
    staticClass: "ranking-con-title"
  }, [_vm._v(_vm._s(_vm.$lang("Market Cap Ranking")))]), _c('div', {
    staticClass: "ranking-head"
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang("Token Name/Symbol")))]), _c('span', [_vm._v(_vm._s(_vm.$lang("Market Cap")))])]), _c('div', {
    staticClass: "ranking-list"
  }, [!_vm.mcapRankLoading ? _vm._l(_vm.mcapRank, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "ranking-item hover",
      on: {
        "click": function ($event) {
          return _vm.onSkip(item);
        }
      }
    }, [_c('span', [_c('div', {
      staticClass: "ranking-icon",
      style: {
        borderColor: index === 0 && '#f2ea0c' || index === 1 && '#33b9eb' || index === 2 && '#e67c15' || index > 2 && '#7d7b90'
      }
    }, [item.icon ? _c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    }) : _c('m-img-empty'), _c('div', {
      staticClass: "ranking-tag",
      style: {
        borderColor: index === 0 && '#f2ea0c' || index === 1 && '#33b9eb' || index === 2 && '#e67c15' || index > 2 && '#7d7b90'
      }
    }, [_vm._v(_vm._s(index + 1))])], 1), _c('em', {
      attrs: {
        "title": item.name
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('i', [_vm._v("(" + _vm._s(item.symbol) + ")")])]), _c('span', [_vm._v("$ " + _vm._s(item.marketCap))])]);
  }) : _vm._l(_vm.perPage, function (_) {
    return _c('div', {
      staticClass: "ranking-item empty"
    });
  })], 2)]), _c('div', {
    staticClass: "ranking-con"
  }, [_c('div', {
    staticClass: "ranking-con-title"
  }, [_vm._v(_vm._s(_vm.$lang("24H Trading Volume Ranking")))]), _c('div', {
    staticClass: "ranking-head"
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang("Token Name/Symbol")))]), _c('span', [_vm._v(_vm._s(_vm.$lang("Market Cap")))]), _c('span', [_vm._v(_vm._s(_vm.$lang("Trading Volume")))])]), _c('div', {
    staticClass: "ranking-list"
  }, [!_vm.volumeRankLoading ? _vm._l(_vm.volumeRank, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "ranking-item hover",
      on: {
        "click": function ($event) {
          return _vm.onSkip(item);
        }
      }
    }, [_c('span', [_c('div', {
      staticClass: "ranking-icon",
      style: {
        borderColor: index === 0 && '#f2ea0c' || index === 1 && '#33b9eb' || index === 2 && '#e67c15' || index > 2 && '#7d7b90'
      }
    }, [item.icon ? _c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    }) : _c('m-img-empty'), _c('div', {
      staticClass: "ranking-tag",
      style: {
        borderColor: index === 0 && '#f2ea0c' || index === 1 && '#33b9eb' || index === 2 && '#e67c15' || index > 2 && '#7d7b90'
      }
    }, [_vm._v(_vm._s(index + 1))])], 1), _c('em', {
      staticClass: "xr",
      attrs: {
        "title": item.name
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('i', [_vm._v("(" + _vm._s(item.symbol) + ")")])]), _c('span', [_vm._v("$ " + _vm._s(item.marketCap))]), _c('span', {
      staticClass: "g",
      domProps: {
        "innerHTML": _vm._s(`$ ${item.tradingVolume}`)
      }
    })]);
  }) : _vm._l(_vm.perPage, function (_) {
    return _c('div', {
      staticClass: "ranking-item empty"
    });
  })], 2)]), _c('div', {
    staticClass: "ranking-con"
  }, [_c('div', {
    staticClass: "ranking-con-title"
  }, [_vm._v(_vm._s(_vm.$lang("Gainers Ranking")))]), _c('div', {
    staticClass: "ranking-head"
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang("Token Name/Symbol")))]), _c('span', [_vm._v(_vm._s(_vm.$lang("Market Cap")))]), _c('span', [_vm._v(_vm._s(_vm.$lang("Price Gain 24h")))])]), _c('div', {
    staticClass: "ranking-list"
  }, [!_vm.diffRankLoading ? _vm._l(_vm.diffRank, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "ranking-item hover",
      on: {
        "click": function ($event) {
          return _vm.onSkip(item);
        }
      }
    }, [_c('span', [_c('div', {
      staticClass: "ranking-icon",
      style: {
        borderColor: index === 0 && '#f2ea0c' || index === 1 && '#33b9eb' || index === 2 && '#e67c15' || index > 2 && '#7d7b90'
      }
    }, [item.icon ? _c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    }) : _c('m-img-empty'), _c('div', {
      staticClass: "ranking-tag",
      style: {
        borderColor: index === 0 && '#f2ea0c' || index === 1 && '#33b9eb' || index === 2 && '#e67c15' || index > 2 && '#7d7b90'
      }
    }, [_vm._v(_vm._s(index + 1))])], 1), _c('em', {
      staticClass: "xr",
      attrs: {
        "title": item.name
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('i', [_vm._v("(" + _vm._s(item.symbol) + ")")])]), _c('span', [_vm._v("$ " + _vm._s(item.marketCap))]), _c('span', {
      staticClass: "g",
      domProps: {
        "innerHTML": _vm._s(`${item.priceGain24h}%`)
      }
    })]);
  }) : _vm._l(_vm.perPage, function (_) {
    return _c('div', {
      staticClass: "ranking-item empty"
    });
  })], 2)]), _c('div', {
    staticClass: "ranking-con"
  }, [_c('div', {
    staticClass: "ranking-con-title"
  }, [_vm._v(_vm._s(_vm.$lang("Almost Migrated Ranking")))]), _c('div', {
    staticClass: "ranking-head"
  }, [_c('span', [_vm._v(_vm._s(_vm.$lang("Token Name/Symbol")))]), _c('span', [_vm._v(_vm._s(_vm.$lang("Market Cap")))]), _c('span', [_vm._v(_vm._s(_vm.$lang("Curve progress")))])]), _c('div', {
    staticClass: "ranking-list"
  }, [!_vm.mcapRankLoading ? [_vm.mcapRank && _vm.mcapRank.length > 0 ? _vm._l(_vm.mcapRank, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "ranking-item hover",
      on: {
        "click": function ($event) {
          return _vm.onSkip(item);
        }
      }
    }, [_c('span', [_c('div', {
      staticClass: "ranking-icon",
      style: {
        borderColor: index === 0 && '#f2ea0c' || index === 1 && '#33b9eb' || index === 2 && '#e67c15' || index > 2 && '#7d7b90'
      }
    }, [item.icon ? _c('img', {
      attrs: {
        "src": item.icon,
        "alt": ""
      }
    }) : _c('m-img-empty'), _c('div', {
      staticClass: "ranking-tag",
      style: {
        borderColor: index === 0 && '#f2ea0c' || index === 1 && '#33b9eb' || index === 2 && '#e67c15' || index > 2 && '#7d7b90'
      }
    }, [_vm._v(_vm._s(index + 1))])], 1), _c('em', {
      staticClass: "xr",
      attrs: {
        "title": item.name
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('i', [_vm._v("(" + _vm._s(item.symbol) + ")")])]), _c('span', [_vm._v("$ " + _vm._s(item.marketCap))]), _c('span', [_c('div', {
      staticClass: "progress"
    }, [_c('div', {
      staticClass: "progress__label"
    }, [_c('i', {
      domProps: {
        "innerHTML": _vm._s(_vm.fmt_pre(item.sold_token, 6))
      }
    }), _vm._v("%")]), _c('div', {
      staticClass: "progress-main"
    }, [_c('div', {
      staticClass: "bar",
      style: {
        width: (item.pool_ether !== '0' ? item.sold_token : 100) + '%'
      }
    })])])])]);
  }) : [_c('m-empty')]] : _vm._l(_vm.perPage, function (_) {
    return _c('div', {
      staticClass: "ranking-item empty"
    });
  })], 2)])])])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };